import en_header from '../../../../src/locales/en-US/header.json'
import vi_header from '../../../../src/locales/vi-VN/header.json'

import en_footer from '../../../../src/locales/en-US/footer.json'
import vi_footer from '../../../../src/locales/vi-VN/footer.json'

import en_notification from '../../../../src/locales/en-US/notification.json'
import vi_notification from '../../../../src/locales/vi-VN/notification.json'

import en_enrich_modal from '../../../../src/locales/en-US/enrich_modal.json'
import vi_enrich_modal from '../../../../src/locales/vi-VN/enrich_modal.json'

export default {
  en: {
    header: en_header,
    footer: en_footer,
    enrich_modal: en_enrich_modal,
    job_by_location: {
      title: 'Jobs by Locations in Vietnam - Jobs Near You | freec.asia',
      seo_h1: 'Job by locations',
      description:
        'Browse job vacancies near you! Discover job opportunities in various locations in Vietnam with freec.asia: Career Discovery without Limits.'
    },
    notification: en_notification
  },
  vi: {
    header: vi_header,
    footer: vi_footer,
    enrich_modal: vi_enrich_modal,
    job_by_location: {
      title: 'Tuyển dụng, tìm việc làm theo địa điểm - Công việc gần bạn| freec.asia',
      seo_h1: 'Công việc theo địa điểm',
      description:
        'Xem tin tuyển dụng việc làm mới nhất trên 64 tỉnh thành. Khám phá các việc làm gần bạn trong tháng {{time}} tại freec.asia. Tạo CV và ứng tuyển ngay!'
    },
    notification: vi_notification
  }
}
